import request from '@/utils/axios'
const baseUrl = process.env.VUE_APP_BASE_URL

// 用户名密码登录
export const loginByUsername = (params) => request({
  url: `${baseUrl}/blade-auth/oauth/token`,
  method: 'post',
  headers: {
    'Tenant-Id': '000000',
    'User-Type': params.userType,
    'Captcha-Key': params.key,
    'Captcha-Code': params.code
  },
  params: {
    tenantId: '000000',
    username: params.username,
    password: params.password,
    grant_type: 'captcha',
    scope: 'all'
  }
})

// 单点登录
export const ssoLogin = (token, userType) => request({
  url: `${baseUrl}/blade-auth/oauth/token`,
  method: 'post',
  headers: {
    'Tenant-Id': '000000',
    'User-Type': userType
  },
  params: {
    tenantId: '000000',
    grant_type: 'sso',
    token
  }
})

export const logout = () => request({
  url: `${baseUrl}/blade-auth/oauth/logout`,
  method: 'get'
})

// 获取用户中心信息
export const getUserInfo = () => request({
  url: `${baseUrl}/blade-business/experts/mobile/userInfo`,
  method: 'post'
})

// 刷新token
export const refreshToken = (refresh_token) => request({
  url: `${baseUrl}/blade-auth/oauth/token`,
  method: 'post',
  headers: {
    'Tenant-Id': '000000',
    'User-Type': 'individual'
  },
  params: {
    tenantId: '000000',
    refresh_token,
    grant_type: 'refresh_token'
  }
})

export const getCaptcha = () => request({
  url: `${baseUrl}/blade-auth/oauth/captcha`,
  method: 'get'
})

export const registerCompany = (params) => request({
  url: `${baseUrl}/blade-tw-recruit/common/account/company/register`,
  method: 'post',
  headers: {
    // 'Tenant-Id': tenantId,
    'Captcha-Key': params.key,
    'Captcha-Code': params.code
  },
  data: Object.assign(params, {
    grant_type: 'captcha',
    scope: 'all'
  })
})

export const registerIndividual = (params) => request({
  url: `${baseUrl}/blade-tw-recruit/common/account/individual/register`,
  method: 'post',
  headers: {
    // 'Tenant-Id': tenantId,
    'Captcha-Key': params.key,
    'Captcha-Code': params.code
  },
  data: Object.assign(params, {
    grant_type: 'captcha',
    scope: 'all'
  })
})
